import type { CSSProperties } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

type Variant = 'block' | 'input' | 'text'

interface SkeletonProps {
  variant?: Variant
  count?: number
  width?: number | string
  height?: number | string
  rounded?: number | string
  circle?: boolean
  className?: string
  style?: CSSProperties
}

const toCssSize = (value: number | string | undefined): string | undefined =>
  typeof value === 'number' ? `${value}px` : value

const Skeleton = ({
  circle = false,
  className,
  count = 1,
  height,
  rounded = 8,
  style,
  variant = 'block',
  width,
}: SkeletonProps) => {
  if (variant === 'input') {
    return (
      <div className={classNames(styles.group, className)} style={style}>
        {Array.from({ length: count }).map((_, index) => (
          <div className={styles.inputWrapper} key={index}>
            <span className={classNames(styles.skeleton, styles.label)} />
            <span className={classNames(styles.skeleton, styles.control)} />
          </div>
        ))}
      </div>
    )
  }

  if (variant === 'text') {
    return (
      <div className={classNames(styles.group, className)} style={style}>
        {Array.from({ length: count }).map((_, index) => (
          <span
            className={classNames(styles.skeleton, styles.text)}
            key={index}
            style={{
              borderRadius: toCssSize(rounded),
              width: index === count - 1 && count > 1 ? '60%' : (toCssSize(width) ?? '100%'),
              height: toCssSize(height),
            }}
          />
        ))}
      </div>
    )
  }

  return (
    <span
      className={classNames(styles.skeleton, styles.block, className)}
      style={{
        borderRadius: circle ? '50%' : toCssSize(rounded),
        width: toCssSize(width),
        height: toCssSize(height),
        ...style,
      }}
    />
  )
}

export default Skeleton
